import { render, staticRenderFns } from "./DashboardTopBarDailyGoal.vue?vue&type=template&id=44540498&scoped=true&"
import script from "./DashboardTopBarDailyGoal.vue?vue&type=script&lang=js&"
export * from "./DashboardTopBarDailyGoal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTopBarDailyGoal.vue?vue&type=style&index=0&id=44540498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44540498",
  null
  
)

/* custom blocks */
import block0 from "./DashboardTopBarDailyGoal.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports